import { gql } from '@reverbdotcom/commons/src/gql';
import React from 'react';
import ListingNudge from './discovery/listing_nudge';
import { Item2CPOShopDataFragment } from '@reverbdotcom/commons/src/gql/graphql';
import I18n from 'i18n-js';
import { RCPopover, RCIcon } from '@reverbdotcom/cadence/components';
import { InfoCircleIcon } from '@reverbdotcom/cadence/icons/react';

export const ICON_HEIGHT_SMALL = 16;
export const ICON_HEIGHT_MEDIUM = 24;
export const ICON_HEIGHT_BIG = 34;

export const Item2CPOShopFragment = gql(`
  fragment Item2CPOShopData on Shop {
    _id
    id
    certifiedPreOwned {
      title
      description
      tooltipDescription
      badgeIconUrl
      brandName
      pageUrl
      lightModeBrandIconUrl
    }
  }
`);


interface Props {
  shop: Item2CPOShopDataFragment;
}


export function Item2CPOSignal({ shop }: Props) {
  const certifiedPreOwned = shop.certifiedPreOwned;

  if (!certifiedPreOwned) return null;

  const subtitle = <>{certifiedPreOwned.description}</>;
  const title = <>{certifiedPreOwned.title}</>;

  return (
    <ListingNudge
      title={title}
      subtitle={subtitle}
      linkText={I18n.t('discovery.certifiedPreOwned.learnMore')}
      linkUrl={certifiedPreOwned.pageUrl}
      icon={getIconSvg(certifiedPreOwned.badgeIconUrl, ICON_HEIGHT_BIG)}
      key={shop.id}
      linkInline
    />
  );
}

export function Item2CPOTitleCallout({ shop }: Props) {
  const certifiedPreOwned = shop.certifiedPreOwned;

  if (!certifiedPreOwned) return null;

  return (
    <div className="item2-cpo-title">
      {getIconSvg(certifiedPreOwned.badgeIconUrl, ICON_HEIGHT_MEDIUM, ICON_HEIGHT_MEDIUM)}
      {!!certifiedPreOwned.lightModeBrandIconUrl &&
        <>
          {getIconSvg(certifiedPreOwned.lightModeBrandIconUrl, ICON_HEIGHT_BIG)}
          <span className="visually-hidden">{certifiedPreOwned.brandName}</span>
        </>
      }
      <RCPopover
        position="right"
        anchor={
          <button className="button-as-link d-flex gap-1 mt-half">
            <span className="color-primary size-fixed-90">
              {certifiedPreOwned.title}
            </span>
            <span className="color-secondary size-fixed-100">
              <RCIcon svgComponent={InfoCircleIcon} inline />
            </span>
            <span className="visually-hidden">{I18n.t('discovery.certifiedPreOwned.learnMore')}</span>
          </button>
        }
      >
        <>
          {certifiedPreOwned.tooltipDescription}
          <a href={certifiedPreOwned.pageUrl} target="blank" className="text-link ml-1" rel="nofollow">{I18n.t('discovery.certifiedPreOwned.learnMore')}</a>
        </>
      </RCPopover>
    </div>
  );
}


export function getIconSvg(href: string, iconHeight = ICON_HEIGHT_SMALL, iconWidth = 100) {
  return (
    <svg height={iconHeight} width={iconWidth}>
      <image href={href} height={iconHeight} />
    </svg>
  );
}
